import Vue from 'vue';
import Router from 'vue-router';

import store from '@/store';

import LogIn from '@/components/LogIn';
import Account from '@/components/Account';
import TheHome from '@/components/TheHome';

import TheNotificationDetail from '@/components/TheNotificationDetail';
import TheNotification from '@/components/TheNotification';

import Withdrawal from '@/components/Withdrawal';
import WithdrawalsList from '@/components/WithdrawalsList';
import WithdrawalDetail from '@/components/WithdrawalDetail';

import Deal from '@/components/Deal';
import DealsList from '@/components/DealsList';
import DealDetail from '@/components/DealDetail';

import CreateWithdrawRequest from '@/components/CreateWithdrawRequest';

import Advertiser from '@/components/Advertiser';
import Advertisments from '@/components/Advertisments';
import AdvertismentEdit from '@/components/AdvertismentEdit';
import ViewAdvertisement from '@/components/ViewAdvertisement';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/admin/',
  routes: [
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn,
      meta: { noAuth: true }
    },
    {
      path: '/post',
      name: 'Post',
      component: Advertiser,
      meta: { noAuth: true }
    },
    {
      path: '/advertisement/:id',
      name: 'View Advertisement',
      component: ViewAdvertisement,
      meta: { noAuth: true }
    },
    {
      path: '/account/:uuid/:md5/:timezone?',
      name: 'Account',
      component: Account,
      props: true,
      meta: { noAuth: true }
    },
    {
      path: '/createWithdrawRequest',
      name: 'CreateWithdrawRequest',
      component: CreateWithdrawRequest,
      meta: { noAuth: true }
    },
    {
      path: '/',
      name: 'TheHome',
      component: TheHome,
      redirect: { name: 'TheNotificationDetail' },
      children: [
        {
          path: 'notification',
          component: TheNotification,
          children: [
            {
              path: '',
              name: 'TheNotificationDetail',
              component: TheNotificationDetail
            }
          ]
        },
        {
          path: '/advertisements',
          name: 'Advertisements',
          component: Advertisments
        },
        {
          path: '/advertisements/:id',
          name: 'View/Edit Advertisement',
          component: AdvertismentEdit
        },
        {
          path: 'withdrawal',
          component: Withdrawal,
          children: [
            {
              path: '',
              name: 'WithdrawalsList',
              component: WithdrawalsList
            },
            {
              path: ':id',
              props: true,
              name: 'WithdrawalDetail',
              component: WithdrawalDetail
            }
          ]
        },
        {
          path: 'deal',
          component: Deal,
          children: [
            {
              path: '',
              name: 'DealsList',
              component: DealsList
            },
            {
              path: ':id',
              props: true,
              name: 'DealDetail',
              component: DealDetail
            }
          ]
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isAuth = store.getters.currentUser;
  const isAdmin = store.getters.isAdmin;

  if (to.meta.noAuth || isAuth) {
    let userHaveAccess = true;

    if (to.meta.admin && !isAdmin) {
      userHaveAccess = false;
    }

    if (userHaveAccess) {
      next();
    } else {
      next('/');
    }
  } else {
    next('/login?next=' + to.fullPath);
  }
});

export default router;
